import { Box } from '@mui/material';
import { color } from '@/colors';
import type { SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';

interface NodeFooterContainerProps {
  children: ReactNode;
  showSeparator?: boolean;
  sx?: SxProps<Theme>;
}

const separatedFooterSx = {
  // DynamicNode content is inset by 16px. Pull the footer out by that inset so
  // the separator reaches the node edges, then re-inset the footer content.
  width: 'calc(100% + 32px)',
  mx: -2,
  px: 2,
  borderTop: `1px solid ${color.White08_T}`,
  pt: 2,
} as const;

export function NodeFooterContainer({ children, showSeparator = false, sx }: NodeFooterContainerProps) {
  if (!showSeparator) {
    return <>{children}</>;
  }

  const sxArray: SxProps<Theme> = Array.isArray(sx) ? sx : sx ? [sx] : [];
  return <Box sx={[separatedFooterSx, ...sxArray]}>{children}</Box>;
}
